"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _button = _interopRequireDefault(require("@ux/button"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _AdBar = require("./styles/AdBar");
const AdBar = ({
  text,
  imageUrl,
  price,
  onClose = () => {}
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  return /*#__PURE__*/_react.default.createElement(_AdBar.AdBarContainer, {
    className: "d-flex ux-card"
  }, /*#__PURE__*/_react.default.createElement(_AdBar.AdBarContent, {
    "data-testid": "ad-bar-content",
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row"
  }, imageUrl && /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "ad-bar-image",
    "data-cy": "ad-bar-image",
    src: imageUrl,
    alt: "Ad",
    className: "ad-bar-image",
    width: 82,
    height: 30
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "ad-bar-price",
    className: "ad-price font-weight-bold ml-3"
  }, price)), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "ad-bar-text",
    className: "ad-bar-text"
  }, formatMessage({
    id: text
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    icon: /*#__PURE__*/_react.default.createElement(_x.default, null),
    className: "ad-bar-close-button",
    onClick: onClose,
    "data-testid": "ad-bar-close-button",
    "data-cy": "ad-bar-close-button",
    "aria-label": "Close"
  })));
};
exports.AdBar = AdBar;
AdBar.propTypes = {
  text: _propTypes.default.string.isRequired,
  imageUrl: _propTypes.default.string,
  price: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func
};